import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import Card from "../../components/Cards/Card";
import KpiCard from "../../components/KpiCard/KpiCard";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";

const OBJECT_IDS = {
  USER_NAME: "SnDVPdX",
  QUARTER: "hDJWWa",
  KPIS: [
    {
      KPI_NAME: "Sell Out Total",
      KPI_REALIZADO: "nxALwy",
      KPI_META: "cdjnP",
      KPI_ATING: "PegzQZ",
      TABLE_RANKING: "CvEVk",
    },
    {
      KPI_NAME: "Cobertura Qualificada",
      KPI_REALIZADO: "jRcuuZ",
      KPI_META: "SCycYN",
      KPI_ATING: "XAhPZu",
      TABLE_RANKING: "PPwXNjh",
    },
    {
      KPI_NAME: "% Cobertura Formatos",
      KPI_REALIZADO: "VNjKy",
      KPI_META: "enEfLtd",
      KPI_ATING: "hwyVxfW",
      TABLE_RANKING: "gBdMZ",
    },
    {
      KPI_NAME: "% Sell Out DLX",
      KPI_REALIZADO: "PmEfbXK",
      KPI_META: "ZwKC",
      KPI_ATING: "rmND",
      TABLE_RANKING: "KDzzTJ",
    },
  ],
};

function OverviewDesktop({ app, config }) {
  const { selections } = useSelections();

  const [nameUser, setNameUser] = useState("");
  const [quater, setQuater] = useState("");

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  const getQuater = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setQuater(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
    }
  }, [app, getNameUser, selections]);

  useEffect(() => {
    if (app) {
      getQuater(OBJECT_IDS.QUARTER);
    }
  }, [app, getQuater, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            rowGap={2}
          >
            {/* Título */}
            <Grid>
              <Card className="container-card-title">
                <h1 className="title">Olá, {nameUser}</h1>
                <p className="text">
                  Nesta tela você consegue ter uma visão geral de todos os KPIs.
                  Para analisar os detalhes de cada indicador, utilize o menu
                  lateral.
                </p>
                <p className="text-quarter">Período analisado: {quater}</p>
              </Card>
            </Grid>

            {/* KPIS e tabela */}
            <Grid container className="container-cards-kpi">
              {OBJECT_IDS.KPIS.map((item) => (
                <Card app={app} className={"card-kpi-item"}>
                  <KpiCard
                    app={app}
                    KPITitle={item.KPI_NAME}
                    valueId={item.KPI_META}
                    goalValueId={item.KPI_REALIZADO}
                    percentageId={item.KPI_ATING}
                    hasProgressBar={true}
                    fullView
                  />

                  <p className="text-kpi-table">Ranking</p>

                  <NativeObject
                    app={app}
                    key={item.TABLE_RANKING}
                    style={{ width: "100%", height: "480px" }}
                    reference={{ id: item.TABLE_RANKING }}
                    className={"table-item-ranking"}
                  />
                </Card>
              ))}
            </Grid>

            {/* tabela de Performance */}
            <Grid container className="container-table-performance">
              <Card
                app={app}
                header={{
                  hardTitle: "Performance por Distribuidor",
                }}
                className={"card-table"}
              >
                <div className="container-legends">
                  <p className="legends meta">
                    <span className="legend-color" />
                    <span className="legend-text">Meta</span>
                  </p>

                  <p className="legends sell-out">
                    <span className="legend-color" />
                    <span className="legend-text">Sell Out de {quater}</span>
                  </p>

                  <p className="legends realizado">
                    <span className="legend-color" />
                    <span className="legend-text">
                      Realizado no Quarter anterior
                    </span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="bxPssg"
                  reference={{ id: "bxPssg" }}
                  style={{
                    width: "100%",
                    height: "300px",
                  }}
                />
              </Card>
            </Grid>

            <Footer app={app} />
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
